import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Dashboard from '../pages/Dashboard/Dashboard';
import CreateSystem from '../pages/System/CreateSystem';
import SystemList from '../pages/System/SystemList';
import UpdateSystem from '../pages/System/UpdateSystem';
import CreateOrgan from '../pages/Organ/CreateOrgan';
import OrganList from '../pages/Organ/OrganList';
import UpdateOrgan from '../pages/Organ/UpdateOrgan';
import CreateDiagnosis from '../pages/Diagnosis/CreateDiagnosis';
import DiagnosisList from '../pages/Diagnosis/DiagnosisList';
import UpdateDiagnosis from '../pages/Diagnosis/UpdateDiagnosis';
import CreateQuestion from '../pages/Question/CreateQuestion';
import QuestionList from '../pages/Question/QuestionList';
import CreateFreeUser from '../pages/ManageAccess/CreateFreeUser';
import FreeUserList from '../pages/ManageAccess/FreeUserList';
import UpdateFreeUser from '../pages/ManageAccess/UpdateFreeUser';
import UserList from '../pages/Users/UserList';
import ContributorList from '../pages/Contributors/ContributorList';
import NotFound from '../pages/NotFound';
import CreateCaseStudy from '../pages/CaseStudy/CreateCaseStudy';
import CaseStudyList from '../pages/CaseStudy/CaseStudyList';
import ViewCaseStudy from '../pages/CaseStudy/ViewCaseStudy';

const AppRoutes = () => {
  return (
    <div>
      <Switch>
        <Route exact path='/dashboard' component={Dashboard} />
        <Route exact path='/create-system' component={CreateSystem} />
        <Route exact path='/system-list' component={SystemList} />
        <Route exact path='/update-system' component={UpdateSystem} />
        <Route exact path='/create-organ' component={CreateOrgan} />
        <Route exact path='/organ-list' component={OrganList} />
        <Route exact path='/update-organ' component={UpdateOrgan} />
        <Route exact path='/create-diagnosis' component={CreateDiagnosis} />
        <Route exact path='/diagnosis-list' component={DiagnosisList} />
        <Route exact path='/update-diagnosis' component={UpdateDiagnosis} />
        <Route exact path='/create-question' component={CreateQuestion} />
        <Route exact path='/question-list' component={QuestionList} />
        <Route exact path='/create-free-user' component={CreateFreeUser} />
        <Route exact path='/free-user-list' component={FreeUserList} />
        <Route exact path='/free-user-list' component={FreeUserList} />
        <Route exact path='/update-free-user' component={UpdateFreeUser} />
        <Route exact path='/all-users' component={UserList} />
        <Route exact path='/all-contributors' component={ContributorList} />
        <Route exact path='/create-case-study' component={CreateCaseStudy} />
        <Route exact path='/case-study-list' component={CaseStudyList} />
        <Route exact path='/case-study/details/:id' component={ViewCaseStudy} />
        <Route path='*' component={NotFound} />
      </Switch>
    </div>
  );
};

export default AppRoutes;
